import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Tiny inline auth indicator + logout link for the studio header.
 * Renders as: `signed in as you@x · log out ›`
 */
export default function StudioAuthNav() {
  const { user, logout } = useAuth();
  if (!user || !user.user_id) return null;
  return (
    <span
      className="inline-flex items-center gap-2 text-xs"
      style={{ color: "#8C8198" }}
      data-testid="studio-auth-nav"
    >
      <span data-testid="studio-auth-email">{user.email}</span>
      <span aria-hidden="true">&middot;</span>
      <button
        type="button"
        onClick={logout}
        data-testid="studio-logout"
        className="underline underline-offset-4 hover:text-[#1B6C7A] transition-colors"
        style={{ fontFamily: "'Courier Prime', monospace" }}
      >
        Log out
      </button>
    </span>
  );
}
